import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { MenuService } from '../menu/menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AsistenteChatService } from './asistente-chat.service';
import { Asistente } from 'src/app/asistente-en-linea/models/Asistente';
import { AreaFuncionalGAFU } from '../../models/area-funcional-gafu';
import { Role } from '../../models/role';
import { Destinatario } from 'src/app/asistente-en-linea/models/Destinatario';
import { DestinatariosService } from '../destinatarios/destinatarios.service';

@Component({
  selector: 'app-asistente-chat',
  templateUrl: './asistente-chat.component.html',
  styleUrls: ['./asistente-chat.component.scss'],
})
export class AsistenteChatComponent implements OnInit {
  codigo: string = '';
  nombre: string = '';
  encoladoMaximo: number;
  reenviarHistorico = true;
  requiereEncuesta = false;
  codigoEncuesta: string = '';
  habilitado: boolean = false;
  areaFuncional: string = '';
  requiereAutenticacion: boolean = false;
  tema: string = '';
  destinatario: number;
  EsEdicion: boolean = false;
  IdAsistente: number;
  error: string = "";
  loading: boolean = false;
  errorValidacionCreacion: boolean = false;
  areasFuncionalesGAFU: AreaFuncionalGAFU[];
  areaFuncionalSeleccionada: AreaFuncionalGAFU;
  gafuAreaFuncional: string;
  esUsuarioAdminitrador: boolean = false;
  destinatarios: Destinatario[] = [];


  constructor(private authService: AuthService,
    private router: Router,
    private readonly route: ActivatedRoute,
    private readonly asistenteChatService: AsistenteChatService,
    private readonly menuService: MenuService,
    private readonly destinatariosService: DestinatariosService
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.idAsistente) {
        this.EsEdicion = true;
        this.IdAsistente = params.params.idAsistente;
        this.loadAsistente(this.IdAsistente);
      }
    })

    this.areasFuncionalesGAFU = [];

    this.esUsuarioAdminitrador = this.authService.esAdministrador();
    // this.esUsuarioAdminitrador = false;

    if (!this.esUsuarioAdminitrador) {
      this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU("Acceso a todas las areas funcionales", "*", "Todos"));
      for (let area of this.authService.getUser().areasFuncionales) {
        this.areasFuncionalesGAFU.push(area);
      }
    }

    this.myOptionsAreasFunciones = this.areasFuncionalesGAFU.map((a: AreaFuncionalGAFU) => ({ label: a.descripcion, value: a.areaFuncional }));

    this.loadDestinatarios();

  }

  myOptions = [
    { label: '0', value: '0' },
    { label: '1', value: '1' },
  ];

  myOptionsDestinatario: { label: string; value: number }[] = [];

  myOptionsAreasFunciones: { label: string; value: string }[] = [];

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  onSelected(selectedValue) {
    this.encoladoMaximo = selectedValue;
  }

  onSelectedDestinatario(selectedValue) {
    this.destinatario = selectedValue;
  }

  onSubmit() {
    this.applyOperation();
  }


  onPaste(e) {
    e.preventDefault();
    return false;
  }

  async applyOperation() {
    this.error = '';
    //debugger
    let resArray = [];
    this.errorValidacionCreacion = false;
    if (this.isDataValid()) {
      this.loading = true;
      let idDest;
      let idDestFin = 0;
      //debugger
      if (this.EsEdicion) {
        resArray.push(await this.asistenteChatService.update(this.IdAsistente, this.codigo, this.nombre, this.nombre, this.areaFuncional, this.habilitado, this.requiereAutenticacion, this.destinatario,
          this.encoladoMaximo, this.reenviarHistorico, this.tema,this.requiereEncuesta,this.codigoEncuesta).toPromise().catch((err) => {
            this.loading = false;
            this.error = err.message;
          }));
      } else {
        resArray.push(await this.asistenteChatService.add(this.codigo, this.nombre, this.nombre, this.areaFuncional, this.destinatario, this.encoladoMaximo, this.reenviarHistorico,
          this.tema, this.requiereAutenticacion,this.requiereEncuesta,this.codigoEncuesta).toPromise().catch((err) => {
            this.loading = false;
            this.error = err.message;
          }));

      }

      let noErr = resArray.reduce((previous, current) => {
        idDest = current.id;
        return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
      }, true)
      if (idDest) {
        idDestFin = Number(idDest);
      }
      if (noErr) {
        if (idDestFin < 0) {
          if (idDest === '-1') {
            this.error = "Atención: Ya existe otro menú con el mismo identificador";
          } else if (idDest === '-2') {
            this.error = "Atención: Ya existe otro menú con el mismo nombre";
          } else {
            this.error = "Atención: Ya existe otro menú con el mismo identificador y nombre";
          }
          this.errorValidacionCreacion = true;
        } else {
          this.irPaginaInicio();
        }
        this.loading = false;
      } else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
      }
    } else {
      this.errorValidacionCreacion = true;
    }

  }

  volver() {
    this.router.navigate(['/config/home']);
  }

  isDataValid() {
    this.error = "";
    //debugger
    // if (this.codigo && this.nombre && this.texto && this.gafuAreaFuncional) {
    if (this.codigo && this.nombre && this.areaFuncional) {
      if (this.codigo.length > 60) {
        this.error = "Atención: El código del asistente no puede superar los 60 caracteres";
        return false;
      } else {
        if (/\s/.test(this.codigo)) {
          this.error = "Atención: El código no puede contener espacios en blanco";
          return false;
        } else {
          let isValid = /[a-zA-Z0-9-_]/.test(this.codigo);
          if (!isValid) {
            this.error = "Atención: El código no puede contener caracteres especiales. Solo se admiten números, letras y los caracteres - y _";
            return false;
          }
        }
      }

      if (this.nombre.length > 60) {
        this.error = "Atención: El nombre del asistente no puede superar los 60 caracteres";
        return false;
      }

      if (this.requiereEncuesta) {
        if (this.codigoEncuesta!=undefined && this.codigoEncuesta.length == 0) {
          this.error = "Atención: El código de encuesta es obligatorio";
          return false;
        } else if (this.codigoEncuesta!=undefined && this.codigoEncuesta.length > 50) {
          this.error = "Atención: El código de asistente no puede superar los 50 caracteres";
          return false;
        }
        
      }

      if (this.areaFuncional.length > 20) {
        this.error = "Atención: El código de área funcional del menú no puede superar los 20 caracteres";
        return false;
      }
      return true;
    } else {
      this.error = "Por favor, asegúrese de ingresar todos los campos obligatorios";
      return false;
    }
  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }

  loadAsistente(id) {
    this.loading = true;
    this.asistenteChatService.get(id).subscribe((data: any) => {
      this.loading = false;
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let asistente = data.content as Asistente;
        this.codigo = asistente.codigoAsistente;
        this.nombre = asistente.descripcion;
        this.encoladoMaximo = asistente.chatDTO.encoladoMaximo;
        this.reenviarHistorico = asistente.chatDTO.guardarHistorico;
        this.requiereEncuesta = asistente.chatDTO.requiereEncuesta;
        this.codigoEncuesta = asistente.chatDTO.codigoEncuesta;
        this.areaFuncional = asistente.gafuAreaFuncional;
        this.tema = asistente.chatDTO.tema;
        this.destinatario = asistente.chatDTO.idDestinatario;
        this.habilitado = asistente.habilitado;
        this.requiereAutenticacion = asistente.requiereAutenticacion;
      }
      else {
        alert(data.statusMessage);
      }
    },
      error => {
        alert(error);
        this.loading = false;
      })
  }

  asignarValorArea() {
    this.gafuAreaFuncional = this.areaFuncionalSeleccionada ? this.areaFuncionalSeleccionada.areaFuncional : "";
    console.log(this.gafuAreaFuncional)
  }

  loadDestinatarios() {
    this.destinatarios = [];
    this.destinatariosService.loadDestinatariosMenu(false).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let destinatario = new Destinatario(
              m.id,
              m.codigo,
              m.descripcion,
              m.titulo,
              m.targetType,
              m.target,
              this.getFormattedDate(new Date(m.fechaCreacion)),
              this.getFormattedDate(new Date(m.fechaActualizacion)),
              m.usuarioAutualizador,
              m.habilitado
            );

            if (destinatario.targetType === 'Workgroup') {
              this.destinatarios.push(destinatario);
            }
          }

          console.log(this.destinatarios)
          this.myOptionsDestinatario = this.destinatarios.map((a: Destinatario) => ({ label: a.titulo + " - " + a.target, value: a.id }));

        }
      }
      else {
        alert(data.statusMessage);
      }
    },
      error => {
        alert(error);
      })
  }

  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
  }
}